@if (formControl) {
  <div class="position-relative d-flex">
    @if (formControl) {
      <input
        [type]="type()"
        [formControl]="formControl"
        [placeholder]="placeholder()"
        [class]="class()"
        [corePositiveNumbers]="noNegative()"
        [coreNumberValue]="isNumber()"
        [readonly]="readonly()"
        [ngClass]="{
          'bg-transparent': !global(),
          'form-control-lg form-control-solid': global(),
          'is-invalid':
            !skipValidation() && control()!['touched'] && control()!.invalid,
          'is-valid':
            !skipValidation() && control()!.valid && formControl.value,
        }"
        coreNoLeadingSpace
        class="form-control form-control-lg password-control"
      />
    }
    <button
      type="button"
      class="btn btn-md btn-primary password-button"
      (click)="togglePasswordVisibility()"
    >
      <ui-keenicon
        [name]="!showPassword ? 'eye-slash' : 'eye'"
        [class]="'fs-3 text-white'"
      ></ui-keenicon>
    </button>
  </div>
}
@if (!formControl) {
  <div class="position-relative d-flex">
    <input
      [value]="value()"
      [type]="type()"
      [placeholder]="placeholder()"
      [class]="class()"
      [corePositiveNumbers]="noNegative()"
      [readonly]="readonly()"
      [ngClass]="{
        'bg-transparent': !global(),
        'form-control-lg form-control-solid': global(),
      }"
      coreNoLeadingSpace
      class="form-control form-control-lg password-control"
    />
    <button
      type="button"
      class="btn btn-md btn-primary password-button"
      (click)="togglePasswordVisibility()"
    >
      <ui-keenicon
        [name]="!showPassword ? 'eye-slash' : 'eye'"
        [class]="'fs-3 text-white'"
      ></ui-keenicon>
    </button>
  </div>
}

@if (formControl && !skipValidation() && control()!['touched']) {
  <ui-validation-form [control]="control()!"></ui-validation-form>
}
@if (description()) {
  <div class="form-text">{{ description() }}</div>
}
